import { FC, useMemo } from "react";
import StarRate from "../../../components/StarRate";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { scoreToDisplayStars } from "../../../config/rating";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

const FILTER_PILLS = ["All", "5★", "1★"];

/** Review List (v2) — admin-preview-only. Real embed markup lives in widget-v2.js (renderList). */
const WidgetTemplate30: FC<IWidgetTemplate> = ({ company, score, review, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("list", style);
  const payload = useMemo(() => ({ companyId, widgetId: 30 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-list`,
    [companyId],
  );
  const starsValue = scoreToDisplayStars(score?.score ?? 0);
  const items = (review?.data ?? []).slice(0, 2);

  return (
    <a
      href={profileUrl}
      target="_blank"
      rel="noopener"
      onClick={() => ReachClick(payload)}
      className="d-block"
      style={{ textDecoration: "none", color: "#1c1c2e", maxWidth: 300, margin: "0 auto" }}
    >
      {resolvedStyle !== "list-only" && (
        <div className="d-flex align-items-center gap-2" style={{ paddingBottom: 6, marginBottom: 6, borderBottom: "1px solid #e7e8ec" }}>
          <b style={{ fontSize: 16 }}>{starsValue}</b>
          <StarRateNewTrustScore value={score?.score} size={9} />
          <span style={{ fontSize: 9.5, color: "#6b6b85" }}>{(score?.totalReview ?? 0).toLocaleString()} reviews</span>
          {resolvedStyle === "with-filters" && (
            <span className="d-flex gap-1" style={{ marginLeft: "auto" }}>
              {FILTER_PILLS.map((f, i) => (
                <span
                  key={f}
                  style={{
                    fontSize: 8.5,
                    fontWeight: 600,
                    borderRadius: 999,
                    padding: "2px 6px",
                    background: i === 0 ? "#006bf1" : "#f7f8fa",
                    color: i === 0 ? "#fff" : "#6b6b85",
                  }}
                >
                  {f}
                </span>
              ))}
            </span>
          )}
        </div>
      )}
      {items.map((item, i) => (
        <div key={item.id} className="d-flex align-items-start gap-2" style={{ fontSize: 10, marginBottom: i === items.length - 1 ? 0 : 6 }}>
          <StarRate value={item.score} size={7} />
          <span className="flex-grow-1 text-truncate">{item.title}</span>
          <span style={{ color: "#9aa0b4", flexShrink: 0 }}>{item.user?.displayName ?? "Verified user"}</span>
        </div>
      ))}
    </a>
  );
};

export default WidgetTemplate30;
